import { useEffect, useState } from 'react';

import { AgentPortalFeatureCode } from '@wallet-manager/pfh-pmp-node-def-types';

import PermissionTab from '../../../components/Layout/PermissionTab';
import { usePermission } from '../../../hooks';
import useTranslation, { Iprefix } from '../../../hooks/useTranslation';
import BalanceTab from './BalanceTab';
import { getTabTranslatePrefix } from './helper';
import HistoryTab from './HistoryTab';

export default function ProgramAgentWallet() {
  const translatePrefix: Iprefix = 'programAgentWallet';
  const [forcedTabValue, setForcedTabValue] = useState<Iprefix>();
  const [defaultCurrencyFilter, setDefaultCurrencyFilter] = useState<string>('');
  const { hasPermission } = usePermission();
  const { t } = useTranslation(translatePrefix);

  const redirectToHistoryTab = (currency: string) => {
    if (
      !hasPermission(
        AgentPortalFeatureCode.ProgramAgentManagement.ProgramAgentWallet.HistoryTab.prefix
      )
    ) {
      return;
    }

    setForcedTabValue(getTabTranslatePrefix('historyTab'));
    setDefaultCurrencyFilter(currency);
  };

  useEffect(() => {
    if (!forcedTabValue) {
      setDefaultCurrencyFilter('');
      return;
    }

    setForcedTabValue(undefined);
  }, [forcedTabValue]);

  return (
    <PermissionTab
      contentArr={[
        {
          translatePrefix: getTabTranslatePrefix('balanceTab'),
          element: <BalanceTab redirectToHistoryTab={redirectToHistoryTab} />,
        },
        {
          translatePrefix: getTabTranslatePrefix('historyTab'),
          element: <HistoryTab defaultCurrencyFilter={defaultCurrencyFilter} />,
        },
      ]}
      tabsArr={[
        {
          name: t('balanceTab.title'),
          value: getTabTranslatePrefix('balanceTab'),
          permissionCode:
            AgentPortalFeatureCode.ProgramAgentManagement.ProgramAgentWallet.BalanceTab.prefix,
        },
        {
          name: t('historyTab.title'),
          value: getTabTranslatePrefix('historyTab'),
          permissionCode:
            AgentPortalFeatureCode.ProgramAgentManagement.ProgramAgentWallet.HistoryTab.prefix,
        },
      ]}
      forcedTabValue={forcedTabValue}
    />
  );
}
